/**
 * en.json is flat and its keys are whole sentences, so i18next must read every key literally: no key separator (".")
 * and no namespace separator (":"). With i18next's defaults a key holding a ":" but no space, ",", "?", "!" or ";"
 * reads the text before the ":" as a namespace: "Tip:", "Name:" and "{{name}}:" rendered "" and
 * "https://your-idp.com/logout" rendered "//your-idp.com/logout". Web's init (./index.ts) spreads this; mobile's init
 * (packages/mobile/src/i18n/index.ts) sets the same two options; __tests__/literalKeys.test.ts holds both.
 */
export const I18N_LITERAL_KEYS = { keySeparator: false, nsSeparator: false } as const;
